import React from "react";
import styled from "styled-components";

import { StyledArrow } from "Components/common/kcArrow";

const Wrapper = styled.div`
  display: flex;
  color: white;
  align-items: flex-end;
  padding: 0.6rem 0;
  border-bottom: 1px solid ${(props) => props.theme.color.dimGrey};
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const StyledTitle = styled.div`
  font-weight: bold;
  font-size: 1.4rem;
  flex: 1;
`;

export default function NavLink({ title, description, handleClick, ...props }) {
  return (
    <Wrapper onClick={() => handleClick()}>
      <StyledTitle>{title}</StyledTitle>
      <StyledArrow color="white" direction="right" />
    </Wrapper>
  );
}
